import { GlLink } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import HiddenBadge from '../../issuable/components/hidden_badge.vue?vue3';
import LockedBadge from '../../issuable/components/locked_badge.vue?vue3';
import ArchivedBadge from '../../issuable/components/archived_badge.vue?vue3';
import { NAMESPACE_PROJECT } from '~/issues/constants';
import ConfidentialityBadge from '../../vue_shared/components/confidentiality_badge.vue?vue3';
import ImportedBadge from '../../vue_shared/components/imported_badge.vue?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { titleInLinkSafeHtmlConfig } from '~/lib/dompurify';
import WorkItemTypeIcon from './work_item_type_icon.vue?vue3';
import { findNotesWidget } from '../utils.js?vue3';
import WorkItemStateBadge from './work_item_state_badge.vue?vue3';
export default {
    name: 'WorkItemStickyHeader',
    components: {
        HiddenBadge,
        ImportedBadge,
        LockedBadge,
        ArchivedBadge,
        ConfidentialityBadge,
        WorkItemStateBadge,
        GlLink,
        WorkItemTypeIcon
    },
    directives: {
        SafeHtml
    },
    props: {
        workItem: {
            type: Object,
            required: true
        },
        isDrawer: {
            type: Boolean,
            required: false,
            default: false
        },
        archived: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        isDiscussionLocked () {
            return findNotesWidget(this.workItem)?.discussionLocked;
        },
        workItemType () {
            return this.workItem.workItemType?.name;
        },
        workItemTypeIconName () {
            return this.workItem.workItemType?.iconName;
        },
        workItemState () {
            return this.workItem.state;
        }
    },
    NAMESPACE_PROJECT,
    TITLE_CLASS: 'gl-mr-auto gl-block gl-truncate gl-pr-3 gl-font-bold gl-text-strong',
    titleInLinkSafeHtmlConfig
};
